import { PwuEntity } from "./PwuEntity";

export const enum ePwuType {
    scoreMultiplier,
}



export class PwuType {
    /**
     * (RO) Typ powerupu
     */
    get type(): ePwuType { return this._type; }
    private _type: ePwuType;

    /**
     * (RO) Delka zivotnosti powerupu v ms
     */
    get lifeLen(): number { return this._lifeLen; }
    private _lifeLen: number;

    get iconFrameKey(): string { return this._iconFrameKey; }
    private _iconFrameKey: string;

    get actFnc(): (pwuEntity: PwuEntity) => void { return this._actFnc; }
    private _actFnc: (pwuEntity: PwuEntity) => void;

    get deactFnc(): () => void { return this._deactFnc; }
    private _deactFnc: () => void;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: ePwuType, lifeLen: number, iconFrameKey: string, actFnc: (pwuEntity: PwuEntity) => void, deactFnc: () => void) {
        this._type = type;
        this._lifeLen = lifeLen;
        this._iconFrameKey = iconFrameKey;
        this._actFnc = actFnc;
        this._deactFnc = deactFnc;
    }
}